export default {
  title: 'Descargar la app {{app}}',
  qr_code_desc: 'Escanea este código QR con tu teléfono para descargar la app',
  cta: '¡Descarga la app e inicia sesión para obtener {{amount}} de reembolso!',
  download_from: 'O descarga desde:',
  direct_link: 'Enlace directo:',
};
